<template>
  <FullScreenMap v-slot="{ fullScreen }">
    <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
      <ShowLocationMap
        :points="plannings"
        :show-info="true"
        :hide-inner-circle="true"
      >
        <template #info="{ point }">
          <h6>{{ point?.name }}</h6>
          {{
            $t('pages.visibility.planning.map.infoWindowText', {
              name: point?.name,
            })
          }}
        </template>
      </ShowLocationMap>
    </Box>
  </FullScreenMap>
</template>

<script lang="ts" setup>
import Box from '@utils/Box.vue';
import { computed } from 'vue';
import ShowLocationMap from '@utils/maps/ShowLocationMap.vue';
import FullScreenMap from '@utils/FullScreenMap.vue';
import { type VisibilityPlanning } from '@/entities/Entities';

interface Props {
  plannings?: VisibilityPlanning[];
}

const props = defineProps<Props>();
const plannings = computed(() => props.plannings?.map((planning: VisibilityPlanning) => ({
  id: planning.id,
  gisLocation: planning.location?.gisLocation,
  radius: 20,
  name: planning.location?.name,
})));
</script>
